import React from 'react';
import { IconProps } from './typing';

const Checkmark = ({ iconSize }: IconProps) => (
  <svg
    width={iconSize}
    height={iconSize}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
  >
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        transform="translate(-1008.000000, -445.000000)"
        fill="#2466F5"
        fillRule="nonzero"
      >
        <g transform="translate(417.000000, 182.000000)">
          <g transform="translate(588.000000, 260.000000)">
            <path
              d="M15,3.5 C21.3512829,3.5 26.5,8.64871708 26.5,15 C26.5,21.3512829 21.3512829,26.5 15,26.5 C8.64871708,26.5 3.5,21.3512829 3.5,15 C3.5,8.64871708 8.64871708,3.5 15,3.5 Z M15,25.016129 C20.5619802,25.016129 25.016129,20.5025221 25.016129,15 C25.016129,9.43801978 20.5025674,4.98387097 15,4.98387097 C9.43801978,4.98387097 4.98387097,9.49747787 4.98387097,15 C4.98387097,20.5619802 9.49743259,25.016129 15,25.016129 Z M21.5675147,12.2659243 L13.198506,20.5678219 C12.980327,20.7842348 12.627971,20.782831 12.4115581,20.564652 L8.42931538,16.5502122 C8.21290244,16.3320332 8.21430625,15.9797225 8.43248527,15.7633096 L8.82754418,15.3714206 C9.04572321,15.1550076 9.39807916,15.1564114 9.61449211,15.3745905 L12.8129568,18.5989124 L20.391893,11.0807928 C20.610072,10.8643799 20.9623827,10.8657384 21.1787956,11.0839174 L21.5706846,11.4790216 C21.7871428,11.6972007 21.7856938,12.0495113 21.5675147,12.2659243 Z"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Checkmark;
